
























import { defineComponent } from "@vue/composition-api";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import TagItem from "@/components/TagItem";

export default defineComponent({
  name: "SelectTagsView",
  components: { TagItem, BasePage, BaseButton, BaseSpinner, CustomScroll },
  props: {
    preSelectedTags: { type: Array as () => string[], default: () => [] },
    tags: { type: Array as () => TagInfo[], required: true },
    saveButtonText: { type: String, default: $t("Save") },
    loading: { type: Boolean, required: true },
    minimumSelection: { type: Number, default: 1 },
    maxSelection: { type: Number, default: 5 },
  },
  data() {
    return {
      selectedTags: {} as Record<string, boolean>,
      saving: false,
    };
  },
  computed: {
    saveDisabled(): boolean {
      return this.getSelectedTags(this.checkedTags).length < this.minimumSelection;
    },
    preSelectedTagsMap(): Record<string, boolean> {
      return this.preSelectedTags.reduce<Record<string, boolean>>((out, item) => {
        out[item] = true;
        return out;
      }, {});
    },
    checkedTags(): Record<string, boolean> {
      return this.tags.reduce<Record<string, boolean>>((out, item) => {
        out[item.id] = this.selectedTags[item.id] ?? this.preSelectedTagsMap[item.id] ?? false;
        return out;
      }, {});
    },
  },
  watch: {
    preSelectedTags() {
      this.selectedTags = {};
    },
  },
  methods: {
    getSelectedTags(tags: Record<string, boolean>): string[] {
      let selectedTags: string[] = [];
      for (const tagId in tags) {
        if (tags[tagId]) selectedTags.push(tagId);
      }
      return selectedTags;
    },

    selectTag(tag: TagInfo, value: boolean) {
      if (this.getSelectedTags(this.checkedTags).length >= this.maxSelection && value) return;
      this.$set(this.selectedTags, tag.id, value);
      this.$emit("input", this.getSelectedTags(this.checkedTags));
    },

    save() {
      this.saving = true;
      this.$emit("save", this.getSelectedTags(this.checkedTags), () => (this.saving = false));
    },
  },
});
